export const ingestionConstants = {
  INGESTION_DETAIL_REQUEST: "INGESTION_DETAIL_REQUEST",
  INGESTION_DETAIL_SUCCESS: "INGESTION_DETAIL_SUCCESS",
  INGESTION_DETAIL_FAILURE: "INGESTION_DETAIL_FAILURE",

  INGESTION_SCRAPE_REQUEST: "INGESTION_SCRAPE_REQUEST",
  INGESTION_SCRAPE_SUCCESS: "INGESTION_SCRAPE_SUCCESS",
  INGESTION_SCRAPE_FAILURE: "INGESTION_SCRAPE_FAILURE",

  INGESTION_RENDER_REQUEST: "INGESTION_RENDER_REQUEST",
  INGESTION_RENDER_SUCCESS: "INGESTION_RENDER_SUCCESS",
  INGESTION_RENDER_FAILURE: "INGESTION_RENDER_FAILURE",

  INGESTION_DISPATCH_REQUEST: "INGESTION_DISPATCH_REQUEST",
  INGESTION_DISPATCH_SUCCESS: "INGESTION_DISPATCH_SUCCESS",
  INGESTION_DISPATCH_FAILURE: "INGESTION_DISPATCH_FAILURE",

  INGESTION_RETRIEVE_REQUEST: "INGESTION_RETRIEVE_REQUEST",
  INGESTION_RETRIEVE_SUCCESS: "INGESTION_RETRIEVE_SUCCESS",
  INGESTION_RETRIEVE_FAILURE: "INGESTION_RETRIEVE_FAILURE",

  INGESTION_CLASSIFY_REQUEST: "INGESTION_CLASSIFY_REQUEST",
  INGESTION_CLASSIFY_SUCCESS: "INGESTION_CLASSIFY_SUCCESS",
  INGESTION_CLASSIFY_FAILURE: "INGESTION_CLASSIFY_FAILURE",
};
